import type { ReactNode } from 'react';

import styles from './Badge.module.css';
import { cx } from './cx';

export type BadgeTone = 'vip' | 'new' | 'premium' | 'count' | 'count-inverted';

export interface BadgeProps {
  children: ReactNode;
  /** Figma TV/Tier badge: VIP (pink), Nuevo (cyan), Premium (purple); `count` = rail counter. */
  tone?: BadgeTone;
  className?: string;
}

export function Badge({ children, tone = 'vip', className }: BadgeProps) {
  return <span className={cx(styles.badge, styles[tone], className)}>{children}</span>;
}
